import type { Melody } from '@tunasong/schemas'
import { Dialog } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { MelodyTrainer } from './melody-trainer.js'

/**
 * The trainer over a melody that is not a page: the block, and the roll editor.
 *
 * It takes the melody VALUE, not an id. That is what makes "Practice" work identically on an
 * embedded melody, which has no entity behind it at all, and on a library one - the same reason
 * the capture dialog takes a value.
 *
 * Spec: docs/superpowers/specs/2026-09-08-melody-plugin-design.md §3, §6
 */

export interface MelodyTrainerDialogProps {
  melody: Melody
  open: boolean
  onClose: () => void
}

export const MelodyTrainerDialog: FC<MelodyTrainerDialogProps> = props => {
  const { melody, open, onClose } = props
  return (
    <Dialog open={open} onClose={onClose} title="Practice melody" fullWidth={true} maxWidth="md">
      {/*
       * Keyed on `open` so each visit starts a fresh session. Without it a dialog re-opened after a
       * session would show the previous summary, and "Practise again" would be the only way back to
       * the welcome screen.
       */}
      {open ? <MelodyTrainer key={String(open)} melody={melody} onClose={onClose} /> : null}
    </Dialog>
  )
}
